export const PREF_CARDS_BASE_ROUTE = 'preference-cards';
const PREF_CARDS_BASE_PATH = `/${PREF_CARDS_BASE_ROUTE}`;
export default PREF_CARDS_BASE_PATH;
